// class-component-decorators.js
import { createDecorator } from '@fwk-node-modules/vue-class-component';

// We create the MetaInfo decorator
export const MetaInfo = createDecorator((options, key) => {
  if (!options.methods) return
  options['metaInfo'] = options.methods[key];
});